// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import AccordionSection, { AccordionSectionProps } from "@insite/mobius/AccordionSection/AccordionSection";
import omitMultiple from "@insite/mobius/utilities/omitMultiple";
import React, { PropsWithChildren } from "react";
import styled from "styled-components";

type State = Pick<AccordionSectionProps, "expanded">;

// XNG-Changes
const ManagedAccordionSectionWrapper = styled.dl`
    margin-block: 0;
`;

/**
 * An accordion section that manages itself, allowing the user to set an initial expanded state and governing expanded
 * and contracted states from there.
 */
class ManagedAccordionSection extends React.Component<
    PropsWithChildren<AccordionSectionProps & { initialExpanded?: boolean }>,
    State
> {
    state = { expanded: this.props.initialExpanded };

    toggle = () => {
        this.setState(
            ({ expanded }) => {
                return { expanded: !expanded };
            },
            () => {
                if (this.props.onTogglePanel) {
                    this.props.onTogglePanel(this.state.expanded ?? false);
                }
            },
        );
    };

    render() {
        // XNG-Changes: add ManagedAccordionSectionWrapper for Accessibility
        return (
            <ManagedAccordionSectionWrapper>
                <AccordionSection
                    {...omitMultiple(this.props, ["onTogglePanel", "expanded"])}
                    expanded={this.state.expanded}
                    onTogglePanel={this.toggle}
                />
            </ManagedAccordionSectionWrapper>
        );
    }
}

export default ManagedAccordionSection;
